export default __webpack_public_path__ + "static/media/bg-cat-dog-one-line.7f4f567f.jpg";